import React, { useEffect, useState, isValidElement, ReactElement, Children, cloneElement } from "react";
import classNames from "classnames";
import { Collapse } from "../Transitions";
import { PanelProps, PanelState } from "./PropsType";

export default function Panel(props: PanelProps) {
  const {
    className,
    children: childrenProps,
    onExpand,
    onFullscreen,
    tool,
    ...other
  } = props;
  const [data, setData] = useState<PanelState>({
    full: false,
    expanded: props.expanded || true,
  });
  const { full, expanded } = data;
  const styleClass = classNames(
    "Panel",
    {
      "Panel-fullwidth": full,
    },
    className
  );
  let headerChildren: any = "";
  const children = Children.map(
    childrenProps,
    (child: ReactElement<any>) => {
      if (!isValidElement(child)) {
        return null;
      }
      const type: any = child.type;
      const fnName = type.fnName;
      if (fnName === "PanelHeader") {
        headerChildren = cloneElement(child as ReactElement<any>, {
          tool,
          onExpand: handleExpandClick,
          onFullscreen: handleFullscreenClick,
        });
        return null;
      }
      return child;
    }
  );

  const handleExpandClick = () => {
    if (props.onExpand) {
      props.onExpand();
    }
    setData({
      ...data,
      expanded: !expanded,
    });
  };

  const handleFullscreenClick = () => {
    if (props.onFullscreen) {
      props.onFullscreen();
    }
    setData({
      ...data,
      full: !full,
    });
  };

  useEffect(() => {
    setData({
      ...data,
      expanded: !!props.expanded,
    });
  }, [props.expanded]);

  return (
    <div className={styleClass} {...other}>
      {headerChildren}
      <Collapse in={expanded} className="PanelBody">
        {children}
      </Collapse>
    </div>
  );
}
